export type AppRoute = {
  name: string
  path: string
  secure: boolean
}

export enum APP_PATHS {
  MAIN = '/',
  SIGN_UP = '/signUp',
  LOGIN_IN = '/login',
  APPLICATION = '/application',
  FORGOT_PASSWORD = '/forgot',
  QUALIFYING_DEVICE = '/device',
  DOWNLOAD_APP = '/download'
}

const HomeRoute: AppRoute = {
  name: 'Home',
  path: APP_PATHS.MAIN,
  secure: false
}

const SignUpRoute: AppRoute = {
  name: 'Sign Up',
  path: APP_PATHS.SIGN_UP,
  secure: false
}

const LoginRoute: AppRoute = {
  name: 'Login Up',
  path: APP_PATHS.LOGIN_IN,
  secure: false
}

export const NavAppRoutes: AppRoute[] = [HomeRoute, SignUpRoute, LoginRoute]
